import AccountDetailsCard from 'Agent/Accounts/components/AccountDetailCards';
import 'Agent/Accounts/components/AccountDetails.sass';
import {getAccountDetails, getAccountImages} from 'Agent/Accounts/ducks/accountDetail';
import {toEither} from 'Core/models/Async';
import {sequenceS} from 'fp-ts/lib/Apply';
import * as E from 'fp-ts/lib/Either';
import {pipe} from 'fp-ts/lib/pipeable';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {RouteComponentProps} from 'react-router';
import {ReducerState} from 'rootReducer';
import {renderAsync} from 'Shared/components/RenderAsync';
import {AgencyFilters} from 'Shared/models/AgencyFilters';
import {useBreadcrumbs} from 'Core/hooks/useBreadcrumbs';

type AccountDetailsProps = {
  selectedAgency: AgencyFilters;
} & RouteComponentProps<{accountId: string; accountNumber: string}>;

const AccountDetails = (props: AccountDetailsProps) => {
  const dispatch = useDispatch();
  const {match} = props;
  const {accountDetails} = useSelector((state: ReducerState) => state.accountDetails);
  const {userClaims} = useSelector((state: ReducerState) => state.user.profile);

  const {accountId, accountNumber} = match.params;
  useBreadcrumbs(accountNumber, props.match.url);

  const {selectedAgency} = props;

  useEffect(() => {
    dispatch(getAccountDetails(selectedAgency.encryptedIdentifier, accountId, accountNumber));
    dispatch(getAccountImages(selectedAgency.encryptedIdentifier, accountId));
  }, [dispatch, accountId, selectedAgency.encryptedIdentifier, accountNumber]);

  return pipe(
    sequenceS(E.either)({
      accountDetails: toEither(accountDetails),
      userClaims: toEither(userClaims),
    }),
    E.fold(renderAsync, ({accountDetails, userClaims}) => (
      <AccountDetailsCard accountDetail={accountDetails} userClaims={userClaims} />
    ))
  );
};

export default AccountDetails;
